import React from 'react';
import { Modal, Form, Row, Col, Table, Tabs, Tab, Spinner, Card } from 'react-bootstrap';
import { useQuery } from 'react-query';
import * as moment from 'moment';
import { Get } from '../../../../../utils/httpProvider';
import { 
    HOSO_TUYENSINH_API, 
    LYLICHKHOAHOC_API, 
    MINHCHUNGKHOAHOC_API, 
    DECUONGNGHIENCUU_API, 
    VANBANGTUYENSINH_API, 
    VANBANGCHUNGCHINGOAINGU_API,
    VANBANGDAIHOC_API,
    NGANH_API,
    CHUYENNGANH_API,
    TRINHDO_API,
    DONVIDAOTAO_API,
    QUOCGIA_API,
    HINHTHUCDAOTAO_API,
    XEPLOAIDAOTAO_API,
    BaseGatewayImage
} from '../../../../../utils/apiUrl';
import { objectAccountGender, objectObjectAccount, objectLoaiVanBang, objectCapQuanLy, objectLoaiCanBoHuongDan, doiTuongValue, loaiVanBangValue, capQuanLyValue, loaiCanBoHuongDanValue, gioiTinh as gioiTinhValue } from '../../../../../utils/define';
import { useDispatch, useSelector } from 'react-redux';
import { getAccountAuthInfoByIdAccountAction, getAccountInfoByIdAccountAction } from '../../../../../store/reducers/account';
import { useEffect } from 'react';

const HoSoTuyenSinhDetailModal = ({ show, handleClose, hoSoId }) => {
    const dispatch = useDispatch();
    const itemAccountAuthInfo = useSelector((state) => state.account.itemAccountAuthInfo);
    const itemAccountInfo = useSelector((state) => state.account.itemAccountInfo);

    // APIs Data
    const { data: hoSo, isLoading: load1 } = useQuery(['hoSoTuyenSinhDetail', hoSoId], () => Get(HOSO_TUYENSINH_API.GET_ITEM, hoSoId), { enabled: !!hoSoId });
    const { data: lyLichRes, isLoading: load2 } = useQuery(['lyLich', hoSoId], () => Get(LYLICHKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: minhChungRes, isLoading: load3 } = useQuery(['minhChung', hoSoId], () => Get(MINHCHUNGKHOAHOC_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: deCuongRes, isLoading: load4 } = useQuery(['deCuong', hoSoId], () => Get(DECUONGNGHIENCUU_API.GET_BY_HOSO_ID, null, { hoSoTuyenSinhId: hoSoId }), { enabled: !!hoSoId });
    const { data: vanBangRes, isLoading: load5 } = useQuery(['vanBang', hoSoId], () => Get(VANBANGTUYENSINH_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });
    const { data: vbNgoaiNguRes, isLoading: load6 } = useQuery(['vbNgoaiNgu', hoSoId], () => Get(VANBANGCHUNGCHINGOAINGU_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });
    const { data: vanBangDaiHocRes, isLoading: loadVanBangDaiHoc } = useQuery(['vanBangDaiHoc', hoSoId], () => Get(VANBANGDAIHOC_API.GET_BY_HOSO_ID, hoSoId), { enabled: !!hoSoId });


    // Dictionaries
    const { data: nganhRes } = useQuery(['nganhData'], () => Get(NGANH_API.GET_PAGING + '?pageSize=1000'), { enabled: show });
    const nganhOptions = (nganhRes?.data?.$values || nganhRes?.data || []).map(item => ({ value: item.id, label: item.tenNganh }));

    const { data: chuyenNganhRes } = useQuery(['chuyenNganhData'], () => Get(CHUYENNGANH_API.GET_PAGING + '?pageSize=1000'), { enabled: show });
    const chuyenNganhOptions = (chuyenNganhRes?.data?.$values || chuyenNganhRes?.data || []).map(item => ({ value: item.id, label: item.tenChuyenNganh, nganhId: item.nganhId }));

    const { data: trinhDoRes } = useQuery(['trinhDoData'], () => Get(TRINHDO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const trinhDoOptions = (trinhDoRes?.data?.$values || trinhDoRes?.data || []).map(item => ({ value: item.id, label: item.tenTrinhDo }));

    const { data: donViDaoTaoRes } = useQuery(['donViDaoTaoData'], () => Get(DONVIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const donViDaoTaoOptions = (donViDaoTaoRes?.data?.$values || donViDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenDonViDaoTao }));

    const { data: quocGiaRes } = useQuery(['quocGiaData'], () => Get(QUOCGIA_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const quocGiaOptions = (quocGiaRes?.data?.$values || quocGiaRes?.data || []).map(item => ({ value: item.id, label: item.tenQuocGia }));

    const { data: hinhThucDaoTaoRes } = useQuery(['hinhThucDaoTaoData'], () => Get(HINHTHUCDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const hinhThucDaoTaoOptions = (hinhThucDaoTaoRes?.data?.$values || hinhThucDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenHinhThuc }));

    const { data: xepLoaiDaoTaoRes } = useQuery(['xepLoaiDaoTaoData'], () => Get(XEPLOAIDAOTAO_API.GET_ALL_PAGING + '?pageSize=1000'), { enabled: show });
    const xepLoaiDaoTaoOptions = (xepLoaiDaoTaoRes?.data?.$values || xepLoaiDaoTaoRes?.data || []).map(item => ({ value: item.id, label: item.tenXepLoai }));

    const isLoading = load1 || load2 || load3 || load4 || load5 || load6 || loadVanBangDaiHoc;

    const dataHoSo = hoSo || {};
    const dataLyLich = lyLichRes?.data || {};
    const dataMinhChung = minhChungRes?.data || {};
    const dataDeCuong = deCuongRes?.data || {};
    
    // Arrays
    const baiBaoKhoaHocs = dataLyLich.baiBaoKhoaHocs?.$values || dataLyLich.baiBaoKhoaHocs || [];
    const deTaiNCKHs = dataMinhChung.deTaiNCKHs?.$values || dataMinhChung.deTaiNCKHs || [];
    const canBoHuongDans = dataDeCuong.canBoHuongDans?.$values || dataDeCuong.canBoHuongDans || [];
    const vanBangTuyenSinhs = vanBangRes?.data?.$values || vanBangRes?.data || [];
    const vanBangNgoaiNgus = vbNgoaiNguRes?.data?.$values || vbNgoaiNguRes?.data || [];
    const vanBangDaiHocs = vanBangDaiHocRes?.data?.$values || vanBangDaiHocRes?.data || [];


    useEffect(() => {
        if (show && dataHoSo?.accountId) {
            dispatch(getAccountAuthInfoByIdAccountAction(dataHoSo.accountId));
            dispatch(getAccountInfoByIdAccountAction(dataHoSo.accountId));
        }
    }, [show, dataHoSo?.accountId, dispatch]);

    const donViName = itemAccountInfo?.donVis?.length > 0 
        ? itemAccountInfo.donVis.map(d => d.tenDonVi).join(', ') 
        : (itemAccountInfo?.donViNgoaiVien || dataHoSo?.donViNgoaiVien || '');

    const getLabelFromEnum = (value, objectEnum, valueMap) => {
        if (value === null || value === undefined || value === '') return '';
        let actualValue = value;
        if (typeof value === 'string' && valueMap) {
            // Exact match
            if (valueMap[value] !== undefined) actualValue = valueMap[value];
            else {
                // CamelCase match
                const camelCase = value.charAt(0).toLowerCase() + value.slice(1);
                if (valueMap[camelCase] !== undefined) actualValue = valueMap[camelCase];
                else {
                    // Case-insensitive
                    const matchKey = Object.keys(valueMap).find(k => k.toLowerCase() === value.toLowerCase());
                    if (matchKey) actualValue = valueMap[matchKey];
                }
            }
        }
        const found = objectEnum.find((item) => item.value === actualValue || item.value == value);
        return found ? found.label : (valueMap ? '' : value);
    };

    // Formatters
    const customLoaiCanBoMap = { ...loaiCanBoHuongDanValue, canBoHuongDanChinh: 0, canBoHuongDanPhu: 1 };
    const getGender = (val) => getLabelFromEnum(val, objectAccountGender, gioiTinhValue);
    const getDoiTuong = (val) => getLabelFromEnum(val, objectObjectAccount, doiTuongValue) || 'Khác';
    const getLoaiVanBang = (val) => getLabelFromEnum(val, objectLoaiVanBang, loaiVanBangValue);
    const getCapQuanLy = (val) => getLabelFromEnum(val, objectCapQuanLy, capQuanLyValue);
    const getLoaiCanBo = (val) => getLabelFromEnum(val, objectLoaiCanBoHuongDan, customLoaiCanBoMap);
    const getNganh = (val) => nganhOptions.find(x => x.value === val)?.label || '';
    const getChuyenNganh = (val) => chuyenNganhOptions.find(x => x.value === val)?.label || '';
    const getTrinhDo = (val) => trinhDoOptions.find(x => x.value === val)?.label || '';
    const getDonViDaoTao = (val) => donViDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getQuocGia = (val) => quocGiaOptions.find(x => x.value === val)?.label || '';
    const getHinhThuc = (val) => hinhThucDaoTaoOptions.find(x => x.value === val)?.label || '';
    const getXepLoai = (val) => xepLoaiDaoTaoOptions.find(x => x.value === val)?.label || '';

    const FieldDisplay = ({ label, value }) => (
        <Form.Group className="mb-3">
            <Form.Label className="font-weight-bold text-muted small">{label}</Form.Label>
            <Form.Control type="text" value={value || ''} disabled className="shadow-none bg-white" />
        </Form.Group>
    );

    const FieldDisplayFile = ({ label, value }) => {
        const getSafeUrl = (path) => {
            if (!path) return null;
            if (path.startsWith('http')) return path;
            const baseUrl = BaseGatewayImage.endsWith('/') ? BaseGatewayImage.slice(0, -1) : BaseGatewayImage;
            const safePath = path.startsWith('/') ? path : `/${path}`;
            return `${baseUrl}${safePath}`;
        };
        const fileUrl = getSafeUrl(value);
        const fileName = value ? value.split('/').pop() : '';
        return (
            <Form.Group className="mb-3">
                {label && <Form.Label className="font-weight-bold text-muted small d-block">{label}</Form.Label>}
                <div>
                    {value ? (
                        <a href={fileUrl} target="_blank" rel="noreferrer" className={`btn btn-outline-primary text-left ${label ? '' : 'btn-sm'}`} style={{ maxWidth: '100%', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap', display: 'inline-block' }} title={fileName}>
                            <i className="fas fa-paperclip mr-1"></i> {fileName}
                        </a>
                    ) : (
                        <div className={label ? "d-flex align-items-center" : ""} style={label ? { height: '38px' } : {}}>
                            <span className="text-muted small">Không có file đính kèm</span>
                        </div>
                    )}
                </div>
            </Form.Group>
        );
    };

    return (
        <Modal show={show} onHide={handleClose} size="xl" backdrop="static" style={{ zIndex: 9999 }}>
            <Modal.Header closeButton className="bg-info text-white">
                <Modal.Title><i className="fas fa-eye mr-2"></i> Chi tiết hồ sơ tuyển sinh</Modal.Title>
            </Modal.Header>
            <Modal.Body style={{ maxHeight: 'calc(100vh - 150px)', overflowY: 'auto' }}>


                {isLoading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-2 text-muted">Đang tải dữ liệu...</p>
                    </div>
                ) : (
                    <Tabs defaultActiveKey="thong-tin-ca-nhan" className="mb-4 custom-tabs">
                        <Tab eventKey="thong-tin-ca-nhan" title={<span><i className="fas fa-user mr-1"></i> Thông tin cá nhân</span>}>
                            <div className="bg-light p-3 rounded border">
                                <Row>
                                    <Col md={12}><FieldDisplay label="Số hồ sơ" value={dataHoSo.soHoSo || dataHoSo.SoHoSo || 'Chưa cấp'} /></Col>
                                    <Col md={4}><FieldDisplay label="Họ tên" value={dataHoSo.hoTen} /></Col>
                                    <Col md={4}><FieldDisplay label="Ngày sinh" value={dataHoSo.ngaySinh ? moment(dataHoSo.ngaySinh).format('DD/MM/YYYY') : ''} /></Col>
                                    <Col md={4}><FieldDisplay label="Giới tính" value={getGender(dataHoSo.gioiTinh)} /></Col>
                                    <Col md={4}><FieldDisplay label="Đối tượng" value={getDoiTuong(dataHoSo.doiTuong)} /></Col>
                                    <Col md={4}><FieldDisplay label="Email" value={dataHoSo.email} /></Col>
                                    <Col md={4}><FieldDisplay label="Số điện thoại" value={dataHoSo.soDienThoai} /></Col>
                                    <Col md={12}><FieldDisplay label="Đơn vị công tác" value={donViName} /></Col>
                                    <Col md={12}><FieldDisplay label="Nơi sinh (Tỉnh / Thành phố)" value={dataHoSo.noiSinh} /></Col>
                                    <Col md={6}><FieldDisplay label="Họ tên người liên hệ" value={dataHoSo.hoTenNguoiLienHe} /></Col>
                                    <Col md={6}><FieldDisplay label="SĐT người liên hệ" value={dataHoSo.sdtNguoiLienHe} /></Col>
                                </Row>
                            </div>
                        </Tab>

                        <Tab eventKey="thong-tin-du-tuyen" title={<span><i className="fas fa-clipboard-list mr-1"></i> Thông tin dự tuyển</span>}>
                            <div className="bg-light p-3 rounded border">
                                <Row>
                                    <Col md={dataHoSo.chuyenNganhId ? 6 : 12}><FieldDisplay label="Ngành đăng ký" value={getNganh(dataHoSo.nganhId)} /></Col>
                                    {dataHoSo.chuyenNganhId && (
                                        <Col md={6}><FieldDisplay label="Chuyên ngành đăng ký" value={getChuyenNganh(dataHoSo.chuyenNganhId)} /></Col>
                                    )}
                                </Row>
                            </div>
                        </Tab>

                        <Tab eventKey="van-bang" title={<span><i className="fas fa-graduation-cap mr-1"></i> Quá trình đào tạo</span>}>
                            <h5 className="font-weight-bold   mt-3 mb-2" style={{ color: "#1e7e34" }}>Văn bằng đại học (Bác sĩ)</h5>
                            {vanBangDaiHocs.length > 0 ? (
                                vanBangDaiHocs.map((vb, idx) => (
                                    <Card key={idx} className="mb-3 shadow-sm border-info">
                                        <Card.Body>
                                            <Row>
                                                <Col md={8}><FieldDisplay label="Trường đào tạo" value={getDonViDaoTao(vb.donViDaoTaoId)} /></Col>
                                                <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                <Col md={6}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                <Col md={6}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))
                            ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng đại học (Bác sĩ)</div>}

                            <h5 className="font-weight-bold   mt-4 mb-2" style={{ color: "#1e7e34" }}>Văn bằng sau đại học</h5>
                            {vanBangTuyenSinhs.length > 0 ? (
                                vanBangTuyenSinhs.map((vb, idx) => (
                                    <Card key={idx} className="mb-3 shadow-sm border-info">
                                        <Card.Body>
                                            <Row>
                                                <Col md={4}><FieldDisplay label="Loại văn bằng" value={getLoaiVanBang(vb.loaiVanBang)} /></Col>
                                                <Col md={8}><FieldDisplay label="Trường đào tạo" value={
                                                    (getLoaiVanBang(vb.loaiVanBang) === 'Nước ngoài') ? vb.tenTruongNuocNgoai : getDonViDaoTao(vb.donViDaoTaoId)
                                                } /></Col>
                                                <Col md={4}><FieldDisplay label="Trình độ" value={getTrinhDo(vb.trinhDoId)} /></Col>
                                                <Col md={4}><FieldDisplay label="Quốc gia" value={getQuocGia(vb.quocGiaId)} /></Col>
                                                <Col md={4}><FieldDisplay label="Hình thức đào tạo" value={getHinhThuc(vb.hinhThucDaoTaoId)} /></Col>
                                                <Col md={4}><FieldDisplay label="Xếp loại" value={getXepLoai(vb.xepLoaiDaoTaoId)} /></Col>
                                                <Col md={6}><FieldDisplay label="Ngành" value={vb.nganhDaoTao} /></Col>
                                                <Col md={6}><FieldDisplay label="Chuyên ngành" value={vb.chuyenNganhDaoTao} /></Col>
                                                <Col md={4}><FieldDisplay label="Điểm luận văn tốt nghiệp" value={vb.diemLuanVanTN} /></Col>
                                                <Col md={4}><FieldDisplay label="Điểm trung bình toàn khóa" value={vb.diemTBToanKhoa} /></Col>
                                                <Col md={4}><FieldDisplay label="Năm tốt nghiệp" value={vb.namTotNghiep} /></Col>
                                                <Col md={12}><FieldDisplayFile label="File minh chứng văn bằng" value={vb.fileMinhChung} /></Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))
                            ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng tuyển sinh</div>}

                            <h5 className="font-weight-bold   mt-4 mb-2" style={{ color: "#1e7e34" }}>Văn bằng/Chứng chỉ ngoại ngữ</h5>
                            {vanBangNgoaiNgus.length > 0 ? (
                                vanBangNgoaiNgus.map((vb, idx) => (
                                    <Card key={idx} className="mb-3 shadow-sm border-warning">
                                        <Card.Body>
                                            <Row>
                                                <Col md={6}><FieldDisplay label="Tên văn bằng/chứng chỉ" value={vb.tenVanBangChungChi} /></Col>
                                                <Col md={6}><FieldDisplay label="Nơi học" value={vb.noiHoc} /></Col>
                                                <Col md={4}><FieldDisplay label="Năm cấp" value={vb.namCap} /></Col>
                                                <Col md={8}><FieldDisplay label="Ghi chú" value={vb.ghiChu} /></Col>
                                                <Col md={12}><FieldDisplayFile label="File minh chứng ngoại ngữ" value={vb.fileMinhChung} /></Col>
                                            </Row>
                                        </Card.Body>
                                    </Card>
                                ))
                            ) : <div className="alert alert-secondary">Không có dữ liệu văn bằng/chứng chỉ ngoại ngữ</div>}
                        </Tab>

                        <Tab eventKey="nghien-cuu" title={<span><i className="fas fa-book mr-1"></i> Nghiên cứu khoa học</span>}>
                            <div className="d-flex justify-content-start align-items-center mt-3 mb-2">
                                <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}>Bài báo khoa học</h5>
                                <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongBaiBao || dataHoSo.SoLuongBaiBao || 0}</strong></h6>
                            </div>
                            {baiBaoKhoaHocs.length > 0 ? (
                                <Table striped bordered hover size="sm">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Tên bài báo</th>
                                            <th>Tạp chí đăng</th>
                                            <th>Năm công bố</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {baiBaoKhoaHocs.map((bb, idx) => (
                                            <tr key={idx}>
                                                <td>{bb.tenBaiBao}</td>
                                                <td>{bb.tapChiDang}</td>
                                                <td>{bb.namCongBo}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : <div className="alert alert-secondary">Không có dữ liệu bài báo khoa học</div>}
                            <div className="mt-2 mb-3">
                                <FieldDisplayFile label="File lý lịch khoa học đính kèm" value={dataLyLich.fileLyLichKhoaHoc} />
                            </div>

                            <div className="d-flex justify-content-start align-items-center mt-4 mb-2">
                                <h5 className="font-weight-bold mb-0 mr-4" style={{ color: "#1e7e34" }}>Đề tài nghiên cứu khoa học</h5>
                                <h6 className="text-primary font-weight-bold mb-0">Số lượng: <strong className="text-danger">{dataHoSo.soLuongDeTaiKhoaHoc || dataHoSo.SoLuongDeTaiKhoaHoc || 0}</strong></h6>
                            </div>
                            {deTaiNCKHs.length > 0 ? (
                                <Table striped bordered hover size="sm">
                                    <thead className="bg-light">
                                        <tr>
                                            <th>Tên đề tài</th>
                                            <th>Cấp quản lý</th>
                                            <th>Năm nghiệm thu</th>
                                        </tr>
                                    </thead>
                                    <tbody>
                                        {deTaiNCKHs.map((dt, idx) => (
                                            <tr key={idx}>
                                                <td>{dt.tenDeTaiNCKH}</td>
                                                <td>{getCapQuanLy(dt.capQuanLy)}</td>
                                                <td>{dt.namNghiemThu}</td>
                                            </tr>
                                        ))}
                                    </tbody>
                                </Table>
                            ) : <div className="alert alert-secondary">Không có dữ liệu đề tài NCKH</div>}
                            <div className="mt-2 mb-3">
                                <FieldDisplayFile label="File minh chứng khoa học đính kèm" value={dataMinhChung.fileMinhChungKhoaHoc} />
                            </div>

                            <div className="bg-light p-3 rounded border mt-4">
                                <h5 className="font-weight-bold mb-3 border-bottom pb-2" style={{ color: "#1e7e34" }}>
                                    <i className="fas fa-file-signature mr-2"></i> Đề cương nghiên cứu & Cán bộ hướng dẫn
                                </h5>
                                <Row>
                                    <Col md={12}><FieldDisplay label="Tên đề cương" value={dataDeCuong.tenDeCuong || ''} /></Col>
                                </Row>
                                <div className="mt-2 mb-3">
                                    <FieldDisplayFile label="File đề cương nghiên cứu đính kèm" value={dataDeCuong.fileMinhChung} />
                                </div>
                                {canBoHuongDans.length > 0 ? (
                                    <Table striped bordered hover size="sm" responsive>
                                        <thead className="bg-white">
                                            <tr>
                                                <th style={{ whiteSpace: 'nowrap' }}>Họ tên</th>
                                                <th style={{ whiteSpace: 'nowrap' }}>Loại cán bộ</th>
                                                <th style={{ whiteSpace: 'nowrap' }}>Đơn vị công tác</th>
                                                <th style={{ width: '25%' }}>Giấy chấp thuận</th>
                                                <th style={{ width: '25%' }}>Minh chứng</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {canBoHuongDans.map((cb, idx) => (
                                                <tr key={idx}>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.hoTen}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{getLoaiCanBo(cb.loaiCanBoHuongDan)}</td>
                                                    <td className="align-middle" style={{ whiteSpace: 'nowrap' }}>{cb.donViCongTac}</td>
                                                    <td className="align-middle"><FieldDisplayFile value={cb.fileLyLichKhoaHoc} /></td>
                                                    <td className="align-middle"><FieldDisplayFile value={cb.fileMinhChungCanBo} /></td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </Table>
                                ) : <p className="text-muted small">Không có cán bộ hướng dẫn</p>}
                            </div>
                        </Tab>

                        <Tab eventKey="ho-so-dinh-kem" title={<span><i className="fas fa-paperclip mr-1"></i> Hồ sơ đính kèm</span>}>
                            <div className="bg-light p-3 rounded border mt-3">
                                <Row>
                                    <Col md={6}><FieldDisplayFile label="Đơn xin dự tuyển" value={dataHoSo.fileDonXinDuTuyen} /></Col>
                                    <Col md={6}><FieldDisplayFile label="Công văn cử đi" value={dataHoSo.fileCongVanCuDi} /></Col>
                                    <Col md={6}><FieldDisplayFile label="Sơ yếu lý lịch" value={dataHoSo.fileSoYeuLyLich} /></Col>
                                    <Col md={6}><FieldDisplayFile label="Giấy khám sức khỏe" value={dataHoSo.fileGiayKhamSucKhoe} /></Col>
                                    <Col md={6}><FieldDisplayFile label="Minh chứng đóng lệ phí" value={dataHoSo.fileMinhChungLePhi} /></Col>
                                </Row>
                            </div>
                        </Tab>
                        
                    </Tabs>
                )}
            </Modal.Body>
        </Modal>
    );
};

export default HoSoTuyenSinhDetailModal;
